import type { WorkspaceDefinition } from '@/core/ui/workspace'

export const APPROVAL_INBOX_PERMISSIONS = ['ApprovalTasks.Read', 'ApprovalTasks.ReadAll', 'TimesheetApprovals.Read', 'TimesheetApprovals.ReadAll', 'Reports.Read']

// "Hôm nay" và Hộp phê duyệt là việc cá nhân của người dùng, cùng một tiêu chí: mỗi nguồn chỉ tải và hiển thị khi người đó
// có quyền với nguồn ấy (backend vẫn enforce). Hôm nay luôn có lịch và việc cá nhân của chính tài khoản nên mở cho mọi người dùng;
// Hộp phê duyệt cần ít nhất một quyền duyệt. Không còn mã pilot riêng cho Hôm nay.
// ADR-109 (điều chỉnh 27/10/2026): thẻ «Theo dõi tiến độ» (Gantt 3 năm, ProgressOverviewView) giữ ở Hộp công việc để quản lý kiểm tra
// hằng ngày không cần vào Trung tâm điều hành; cùng màn với widget «Tổng quan tiến độ» của Dashboard. Quyền WbsNodes.Read như trước lát 3.
export const workInboxWorkspace: WorkspaceDefinition = {
  tabs: [
    { key: 'today', labelKey: 'todayWork.title', icon: 'pi pi-calendar-clock', component: () => import('@/modules/dashboard/TodayView.vue') },
    { key: 'approvals', labelKey: 'nav.approvalInbox', icon: 'pi pi-inbox', permission: APPROVAL_INBOX_PERMISSIONS, permissionMode: 'any',
      component: () => import('@/modules/workflow/ApprovalInboxView.vue') },
    { key: 'progress', labelKey: 'progressOverview.title', icon: 'pi pi-chart-line', permission: ['WbsNodes.Read'],
      component: () => import('@/modules/execution/ProgressOverviewView.vue') },
  ],
}
